/* Autenti Store Locator — lee los puntos de venta desde un CSV subido a
   Contenido > Archivos en Shopify, en vez de un archivo de código fijo. */
(function () {
  'use strict';

  if (typeof L === 'undefined') {
    console.error('[StoreLocator] Falta Leaflet.');
    return;
  }

  var map, markersLayer;
  var markersById = {};
  var stores = [];

  function esc(s) {
    return (s || '').toString()
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function parseCSV(text) {
    var rows = [];
    var row = [];
    var field = '';
    var inQuotes = false;

    text = text.replace(/^\uFEFF/, ''); 

    for (var i = 0; i < text.length; i++) {
      var char = text[i];
      var next = text[i + 1];

      if (inQuotes) {
        if (char === '"' && next === '"') { field += '"'; i++; }
        else if (char === '"') { inQuotes = false; }
        else { field += char; }
      } else {
        if (char === '"') { inQuotes = true; }
        else if (char === ',') { row.push(field); field = ''; }
        else if (char === '\r') { /* ignore */ }
        else if (char === '\n') { row.push(field); rows.push(row); row = []; field = ''; }
        else { field += char; }
      }
    }
    if (field !== '' || row.length) { row.push(field); rows.push(row); }

    if (!rows.length) return [];
    var headers = rows[0].map(function (h) { return h.trim().toLowerCase(); });
    return rows.slice(1)
      .filter(function (r) { return r.length > 1 || (r[0] || '').trim() !== ''; })
      .map(function (r) {
        var obj = {};
        headers.forEach(function (h, idx) { obj[h] = (r[idx] || '').trim(); });
        return obj;
      });
  }

  function normalizeRow(raw) {
    var lat = parseFloat(raw.lat);
    var lng = parseFloat(raw.lng);
    return {
      name: raw.name || raw.nombre || raw.tienda || '',
      address: raw.address || raw.direccion || '',
      city: raw.city || raw.ciudad || raw.region || '',
      phone: raw.phone || raw.telefono || '',
      email: raw.email || raw.correo || '',
      url: raw.url || raw.web || '',
      lat: isNaN(lat) ? null : lat,
      lng: isNaN(lng) ? null : lng
    };
  }

  function brandIcon() {
    var svg = encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36">' +
      '<path d="M12 0C5.4 0 0 5.4 0 12c0 8.4 12 24 12 24s12-15.6 12-24C24 5.4 18.6 0 12 0z" fill="#37933B" stroke="#fff" stroke-width="1.5"/>' +
      '<circle cx="12" cy="12" r="5" fill="#fff"/></svg>'
    );
    return L.divIcon({
      html: '<img src="data:image/svg+xml,' + svg + '" width="28" height="42" />',
      className: '',
      iconSize: [28, 42],
      iconAnchor: [14, 42],
      popupAnchor: [0, -44]
    });
  }

  function popupHtml(store) {
    var html = '<div class="store-locator-popup">';
    html += '<strong>' + esc(store.name) + '</strong>';
    if (store.address) html += '<br><span>' + esc(store.address) + '</span>';
    if (store.city) html += '<br><span>' + esc(store.city) + '</span>';
    if (store.phone) html += '<br><a href="tel:' + esc(store.phone) + '">' + esc(store.phone) + '</a>';
    if (store.email) html += '<br><a href="mailto:' + esc(store.email) + '">' + esc(store.email) + '</a>';
    if (store.url) html += '<br><a href="' + esc(store.url) + '" target="_blank" rel="noopener">Ver más</a>';
    html += '</div>';
    return html;
  }

  function initMap(el) {
    map = L.map(el, { scrollWheelZoom: false }).setView([40.416, -3.703], 6);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 18
    }).addTo(map);
    markersLayer = L.layerGroup().addTo(map);
  }

  function plotStores() {
    if (!markersLayer) return;
    markersLayer.clearLayers();
    markersById = {};

    stores.forEach(function (store, index) {
      if (store.lat === null || store.lng === null) return;
      var marker = L.marker([store.lat, store.lng], { icon: brandIcon() });
      marker.bindPopup(popupHtml(store), { minWidth: 200 });
      marker.addTo(markersLayer);
      markersById[index] = marker;
    });
  }

  function renderList(container, countEl, filter) {
    var q = (filter || '').toLowerCase().trim();
    var filtered = [];
    stores.forEach(function (store, index) {
      if (
        !q ||
        (store.name || '').toLowerCase().indexOf(q) !== -1 ||
        (store.city || '').toLowerCase().indexOf(q) !== -1 ||
        (store.address || '').toLowerCase().indexOf(q) !== -1
      ) {
        filtered.push({ store: store, index: index });
      }
    });

    if (countEl) countEl.textContent = filtered.length;

    if (!filtered.length) {
      container.innerHTML = '<p class="store-locator__empty">No se han encontrado puntos de venta.</p>';
      return;
    }

    container.innerHTML = filtered.map(function (entry) {
      var store = entry.store;
      return (
        '<div class="store-locator__card" data-index="' + entry.index + '">' +
          '<strong class="store-locator__card-name">' + esc(store.name) + '</strong>' +
          (store.address ? '<span class="store-locator__card-row">' + esc(store.address) + '</span>' : '') +
          (store.city ? '<span class="store-locator__card-row">' + esc(store.city) + '</span>' : '') +
          (store.phone ? '<a class="store-locator__card-row" href="tel:' + esc(store.phone) + '">' + esc(store.phone) + '</a>' : '') +
        '</div>'
      );
    }).join('');

    container.querySelectorAll('.store-locator__card').forEach(function (card) {
      card.addEventListener('click', function () {
        var index = card.getAttribute('data-index');
        var marker = markersById[index];
        if (!marker || !map) return;
        map.setView(marker.getLatLng(), 15);
        setTimeout(function () { marker.openPopup(); }, 300);
        container.querySelectorAll('.store-locator__card').forEach(function (c) { c.classList.remove('is-active'); });
        card.classList.add('is-active');
      });
    });
  }

  function showError(root, message) {
    var listEl = root.querySelector('[data-store-locator-list]');
    if (listEl) {
      listEl.innerHTML = '<p class="store-locator__empty">' + esc(message) + '</p>';
    }
  }

  function init() {
    var root = document.querySelector('[data-store-locator]');
    if (!root) return;

    var mapEl = root.querySelector('[data-store-locator-map]');
    var listEl = root.querySelector('[data-store-locator-list]');
    var countEl = root.querySelector('[data-store-locator-count]');
    var searchEl = root.querySelector('[data-store-locator-search]');
    var csvUrl = root.getAttribute('data-csv-url');

    if (mapEl) initMap(mapEl);

    if (!csvUrl) {
      showError(root, 'No se ha configurado el archivo CSV de puntos de venta. Añádelo en los ajustes de esta sección.');
      return;
    }

    fetch(csvUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (text) {
        var rows = parseCSV(text);
        stores = rows.map(normalizeRow).filter(function (s) { return s.name; });
        plotStores();
        if (listEl) renderList(listEl, countEl, '');
        if (searchEl && listEl) {
          searchEl.addEventListener('input', function () {
            renderList(listEl, countEl, searchEl.value);
          });
        }
      })
      .catch(function (err) {
        console.error('[StoreLocator] Error cargando el CSV:', err);
        showError(root, 'No se ha podido cargar el listado de puntos de venta. Comprueba el enlace del archivo CSV.');
      });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();